<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar :hide_search="true" back_path="/delight" active_screen="delight" />
        <div class="text-center" style="margin: 12px" v-if="delight_detail.file">
            <!-- <a-button class="primary-btn ant-button-label-custom custom-btn" @click="downloadPdf(delight_detail.file)">
                <img src="/resources/images/icon-pdf-white.png" style="margin-right: 8px" />
                <strong>ดาวน์โหลด PDF</strong>
            </a-button> -->
            <!-- <a-button @click="visible = true" class="primary-btn ant-button-label-custom custom-btn ml-16">
                <strong>แชร์เอกสาร</strong>
            </a-button> -->
            <a-button size="large" class="text-center default-btn custom-btn br-20" @click="downloadPdf(delight_detail.file)">
                <img src="/resources/images/icon-pdf.png" style="margin-right: 8px; margin-bottom: 4px" />
                <span class="fs-18 color-red" style="line-height: 36px"> {{ $t('ดาวน์โหลด PDF') }}</span>
            </a-button>
            <a-button size="large" class="custom-btn bg-red br-20 ml-16" @click="visible = true">
                <img src="/resources/images/icon-share.png" style="margin-right: 8px; margin-bottom: 4px" />
                <span class="fs-18 color-white" style="line-height: 36px">แชร์เอกสาร</span>
            </a-button>
            <a-modal centered :bodyStyle="{ padding: 0, 'max-width': '100%', 'text-align': 'center' }" :key="visible" :visible="visible" :footer="null" :closable="false">
                <div @click="visible = false">
                    <label class="custom-close w-100"> x close </label>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="facebook" :url="delight_detail.file">
                        <img src="/resources/images/facebook.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Facebook </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="twitter" :url="delight_detail.file">
                        <img src="/resources/images/twitter.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Twitter </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="linkedin" :url="delight_detail.file">
                        <img src="/resources/images/linkedin.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Linkedin </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="telegram" :url="delight_detail.file">
                        <img src="/resources/images/telegram.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Telegram </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="WhatsApp" :url="delight_detail.file">
                        <img src="/resources/images/whats-app.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Whats App </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="pinterest" :url="delight_detail.file">
                        <img src="/resources/images/pinterest.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Pinterest </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="reddit" :url="delight_detail.file">
                        <img src="/resources/images/reddit.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Reddit </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="line" :url="delight_detail.file">
                        <img src="/resources/images/line.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> Line </label>
                        </div>
                    </ShareNetwork>
                </div>
                <div style="margin: 8px; display: inline-block; width: 25%" class="text-center">
                    <ShareNetwork network="email" :url="delight_detail.file">
                        <img src="/resources/images/email.png" style="width: 30%" />
                        <div class="mt-16">
                            <label class="title"> email </label>
                        </div>
                    </ShareNetwork>
                </div>
            </a-modal>
        </div>
        <div class="text-center" style="margin: 16px 20px 20px 20px; margin-bottom: 0; padding-bottom: 8px">
            <img
                :src="delight_detail.image"
                :style="{
                    width: $device == 'mobile' ? '100%' : '50%',
                }"
            />
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            visible: false,
            delight_detail: {},
        };
    },
    mounted() {
        this._mounted();
        console.log('this.$route.query', this.$route.query);
    },
    methods: {
        _mounted: function () {
            this.getDelightDetail(() => (this.getting_data = false));
        },
        downloadPdf(url) {
            window.open(url, '_blank');
        },
        getDelightDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/delight/detail',
                    data: {
                        id: this.$route.query.delight_id,
                    },
                    callback: (res) => {
                        if (res) {
                            this.delight_detail = res;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(delight_detail) {
            var url;
            if (!delight_detail.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.loading = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: delight_detail.id,
                        type: 'delight',
                    },
                    callback: (res) => {
                        console.log('res', res);
                        if (res && res.result == 'complete') {
                            this.getDelightDetail();
                        } else {
                            const complete = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    complete.title += value[0];
                                }
                            }
                            this.$confirm({
                                title: complete.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        this.loading = false;
                    },
                },
            });
        },
    },
};
</script>
<style scoped>
.title {
    font-size: 16px;
}
.custom-btn {
    width: 45%;
    height: 36px;
    font-size: 14px;
}
@media (max-device-width: 413px) {
    .custom-close,
    .custom-btn {
        font-size: 13px;
    }
}
@media (max-device-width: 374px) {
    .custom-close,
    .custom-btn {
        font-size: 11px;
    }
}
.custom-close {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
    padding: 0 8px;
}
</style>
